import React from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';

import WbkdLogoWhite from 'assets/images/logo-white.svg';
import WbkdLogoBlack from 'assets/images/logo.svg';

const LogoWrapper = styled.div`
  width: 100px;
  position: relative;
`;

const Image = styled.img`
  width: 100%;
  height: auto;
`;

const getLogoSrc = (type, inverted, theme) => {
  if (type) {
    return type === 'white' ? WbkdLogoWhite : WbkdLogoBlack;
  }

  if (inverted) {
    return theme.name === 'light' ? WbkdLogoWhite : WbkdLogoBlack;
  }

  return theme.name === 'light' ? WbkdLogoBlack : WbkdLogoWhite;
};

export default ({ type = null, inverted = false }) => {
  const theme = useTheme();
  const logoSrc = getLogoSrc(type, inverted, theme);

  return (
    <LogoWrapper>
      <Image src={logoSrc} alt="webkid logo" />
    </LogoWrapper>
  );
};
